import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {HomeRouteContext} from '../../utils/context';
import {ButtonIcon} from '@homeaway/react-buttons';
import {CHEVRON_DOWN__12} from '@homeaway/svg-defs/lib/defs/CHEVRON_DOWN__12';
import classNames from 'classnames';

import './CategoryAccordion.less';

export default class CategoryAccordion extends Component {
    constructor(props) {
        super(props);

        const {
            allCategories,
            sys: {id},
            isActive,
        } = props;

        const subCategories = allCategories.filter((cat) => {
            return cat.parentId === id;
        });

        this.state = {
            expanded: isActive || false,
            subCategories,
        };
    }

    /* eslint-disable camelcase */
    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            expanded: props.isActive || false,
        });
    }

    expand = () => {
        this.setState({
            expanded: !this.state.expanded,
        });
    };

    headingType = () => {
        const {level, name} = this.props;

        switch (level) {
            case 1:
                return (
                    <p className="CategoryAccordion__parent-heading CategoryAccordion__level-one">
                        {name}
                    </p>
                );
            case 2:
                return (
                    <p className="CategoryAccordion__sub-heading CategoryAccordion__level-two">
                        {name}
                    </p>
                );
            default:
                return <p className="CategoryAccordion__level-three">{name}</p>;
        }
    };

    renderSubcategories = () => {
        const {
            sys: {id},
            allCategories,
            level,
            location,
        } = this.props;
        const {expanded, subCategories} = this.state;
        const hasSubCategories = subCategories.length > 0;

        if (expanded && hasSubCategories) {
            return subCategories.map((cat, idx) => {
                if (cat.parentId === id) {
                    const isActive = location.pathname.indexOf(cat.path) > -1;

                    return (
                        <CategoryAccordion
                            key={idx}
                            {...this.props}
                            isActive={isActive}
                            allCategories={allCategories}
                            location={location}
                            level={level + 1}
                            {...cat}
                        />
                    );
                }

                return null;
            });
        }

        return null;
    };

    collapseMenu = () => {
        const {collapse, isMobile} = this.props;

        if (isMobile) {
            collapse();
        }
    };

    render() {
        const {level, translations} = this.props;
        const {expanded, subCategories} = this.state;
        const hasSubCategories = subCategories.length > 0;

        return (
            <HomeRouteContext.Consumer>
                {(homeRoute) => (
                    <div className="CategoryAccordion">
                        <div
                            className={`CategoryAccordion__container ${
                                level > 1
                                    ? 'CategoryAccordion__container--inner'
                                    : 'CategoryAccordion__container--outer'
                            }`}
                        >
                            <div className="CategoryAccordion__content">
                                <Link
                                    to={`${homeRoute}${this.props.path}`}
                                    className="CategoryAccordion__link"
                                    onClick={this.collapseMenu}
                                >
                                    {this.headingType()}
                                </Link>
                                {hasSubCategories && (
                                    <ButtonIcon
                                        circle
                                        onClick={this.expand}
                                        label={
                                            expanded
                                                ? translations.collapse
                                                : translations.expand
                                        }
                                        size="sm"
                                        svgMarkup={CHEVRON_DOWN__12}
                                        className={classNames(
                                            'CategoryAccordion__button',
                                            {
                                                'CategoryAccordion__button--expanded': expanded,
                                            },
                                        )}
                                    />
                                )}
                            </div>
                            {this.renderSubcategories(homeRoute)}
                        </div>
                    </div>
                )}
            </HomeRouteContext.Consumer>
        );
    }
}
